import React from 'react';

export const PlusIcon = () => <>&#43;</>;
